// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { postNotificationsFormData, getNotificationsCollections } from '@/services/notifications.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getNotificationsCollections().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[0].options = res.data.collections.push_types
          if (process.env.VUE_APP_NAME.includes('wholesale')) {
            this.formData[0].createDateItem[2].options = res.data.collections.notifiable_types.filter(type => type.value !== 'Host')
          } else {
            this.formData[0].createDateItem[2].options = res.data.collections.notifiable_types
          }
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        notification: obj
      }
      Object.keys(params.notification).forEach(res => {
        if (typeof params.notification[res] === 'boolean') {
          if (params.notification[res] === true) params.notification[res] = '1'
          if (params.notification[res] === false) params.notification[res] = '0'
        }
      })
      postNotificationsFormData(params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'notificationManagerList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
